import {
  EventCategory,
  EventPriority,
  PersistedRuntimeEvent,
  RuntimeEvent,
  RuntimeEventSensitivity
} from '../contracts'

export interface RoutingDecision {
  stream: string
  severity: EventPriority
  sensitivity: RuntimeEventSensitivity
}

function inferSensitivity(event: RuntimeEvent): RuntimeEventSensitivity {
  if (event.metadata?.sensitivity) return event.metadata.sensitivity
  if (event.category === EventCategory.SECURITY) return RuntimeEventSensitivity.AUDIT
  if (event.category === EventCategory.AUTHORIZATION) return RuntimeEventSensitivity.AUDIT
  if (event.category === EventCategory.ACCOUNT_BALANCE) return RuntimeEventSensitivity.SENSITIVE
  if (event.category === EventCategory.OPERATIONAL) return RuntimeEventSensitivity.OPERATIONAL
  return RuntimeEventSensitivity.PUBLIC
}

function inferSeverity(event: RuntimeEvent): EventPriority {
  if (event.metadata?.priority) return event.metadata.priority
  const dataSeverity = event.data?.severity
  if (typeof dataSeverity === 'string') {
    const normalized = dataSeverity.toLowerCase()
    if (normalized === EventPriority.LOW) return EventPriority.LOW
    if (normalized === EventPriority.HIGH) return EventPriority.HIGH
    if (normalized === EventPriority.CRITICAL) return EventPriority.CRITICAL
  }
  return EventPriority.NORMAL
}

function deriveStream(event: RuntimeEvent): string {
  if (event.metadata?.stream) return event.metadata.stream

  switch (event.category) {
    case EventCategory.AUTHORIZATION:
      return 'runtime.audit.authorization'
    case EventCategory.ACCOUNT_BALANCE:
      return 'runtime.financial.account_balance'
    case EventCategory.RUNTIME:
      return 'runtime.operational.lifecycle'
    case EventCategory.OPERATIONAL:
      return 'runtime.operational.events'
    case EventCategory.PERFORMANCE:
      return 'runtime.metrics.performance'
    case EventCategory.SECURITY:
      return 'runtime.audit.security'
    case EventCategory.ERROR:
      return 'runtime.operational.errors'
    default:
      return 'runtime.events.misc'
  }
}

export class RuntimeEventRouter {
  static route(event: RuntimeEvent): RoutingDecision {
    return {
      stream: deriveStream(event),
      severity: inferSeverity(event),
      sensitivity: inferSensitivity(event)
    }
  }

  static matchesRoute(event: PersistedRuntimeEvent, stream: string): boolean {
    return event.stream === stream
  }
}